import { useEffect, useState } from 'react'
import { isFunction } from 'lodash'

export default ({ isLoading, placeholder, timeout = 1000, children }) => {
  const [isShowPlaceholder, setShowPlaceholder] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      setShowPlaceholder(true)
    }, timeout)
  }, [isShowPlaceholder, timeout])

  if (isLoading && isShowPlaceholder) {
    return placeholder
  } else if (isLoading) {
    return null
  }
  return isFunction(children) ? children() : children
}
